import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appSelectableCard]',
    standalone: false,
})
export class SelectableCardDirective {
    @Input()
    defaultElevation = 2;

    @Input()
    raisedElevation = 8;

    constructor(private element: ElementRef, private renderer: Renderer2) {
        this.setHoverState(false);
    }

    @HostListener('mouseenter')
    onMouseEnter() {
        this.setHoverState(true);
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.setHoverState(false);
    }

    setHoverState(isHovered: boolean) {
        let elevationClass = `mat-elevation-z${this.defaultElevation}`;
        let styles = `cursor: default`;

        const classesToRemove = Array.from(
            (<HTMLElement>this.element.nativeElement).classList
        ).filter((current) => current.startsWith('mat-elevation-z'));
        classesToRemove.forEach((current) => {
            this.renderer.removeClass(this.element.nativeElement, current);
        });

        if (isHovered) {
            elevationClass = `mat-elevation-z${this.raisedElevation}`;
            styles = `cursor: pointer`;
        }

        this.renderer.addClass(this.element.nativeElement, elevationClass);
        this.renderer.setAttribute(this.element.nativeElement, 'style', styles);
    }
}
